const MobileDiscoveryInsightCard = ({ insight, normalizeUrl }) => {
    const href = normalizeUrl(insight.url);
    const providerHref = normalizeUrl(insight.providerUrl);

    return (
        <article className="mobile-company-card mobile-insight-card">
            <div className="mobile-company-card__body">
                <div className="mobile-company-card__top">
                    <div className="mobile-company-card__meta">
                        <h4 className="mobile-company-card__title">{insight.name || '—'}</h4>
                        <p className="mobile-insight-card__service">{insight.service || '—'}</p>
                        {insight.description && <p className="mobile-insight-card__description">{insight.description}</p>}
                        {providerHref && (
                            <p className="mobile-insight-card__provider">
                                Provider website: <a href={providerHref} target="_blank" rel="noopener noreferrer">{insight.providerUrl}</a>
                            </p>
                        )}
                    </div>
                </div>
            </div>
            <div className="mobile-company-card__stats-strip mobile-company-card__stats-strip--two" aria-label="Insight details">
                <div className="mobile-company-card__stat-cell">
                    <span className="mobile-company-card__stat-label">Google rating</span>
                    <span className="mobile-company-card__stat-value">{(insight.googleRating ?? '') === '' ? '—' : insight.googleRating}</span>
                </div>
                <div className="mobile-company-card__stat-cell">
                    <span className="mobile-company-card__stat-label">Website</span>
                    {href ? (
                        <a className="mobile-company-card__stat-value mobile-insight-card__website"
                            href={href} target="_blank" rel="noopener noreferrer" title={insight.url}>
                            {insight.url}
                        </a>
                    ) : <span className="mobile-company-card__stat-value">—</span>}
                </div>
            </div>
        </article>
    );
};

export default MobileDiscoveryInsightCard;
